import { createContext, useContext, useState, useCallback, useMemo } from "react";
import { LANGUAGES, makeT, translateServerError } from "@/i18n/translations";

const LanguageContext = createContext(null);
const STORAGE_KEY = "mrshu_lang";
const VALID = LANGUAGES.map((l) => l.code);

function detectLanguage() {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored && VALID.includes(stored)) return stored;
  const candidates = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || "en"];
  for (const raw of candidates) {
    const l = (raw || "").toLowerCase();
    if (l === "zh-cn" || l === "zh-sg" || l === "zh-hans" || l === "zh-hans-cn") return "zh-CN";
    if (l === "zh-tw" || l === "zh-hk" || l === "zh-mo" || l === "zh-hant") return "zh-TW";
    if (l.startsWith("ko")) return "ko";
    if (l.startsWith("zh")) return "zh-CN";
  }
  return "en";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectLanguage);

  const setLang = useCallback((code) => {
    if (!VALID.includes(code)) return;
    localStorage.setItem(STORAGE_KEY, code);
    setLangState(code);
  }, []);

  const t = useMemo(() => makeT(lang), [lang]);
  const te = useCallback((msg) => translateServerError(msg, lang), [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, te, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
